import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { fetchPackageDeliveryRanges } from 'actions/packageDeliveryRanges';
import { clearPackageOrderList } from 'actions/packageOrderList';
import { dateFormatter, getIsoDate } from 'theme/utils';
import { hourMinuteFormat } from 'appConstants';

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

let _content = null;

const MobileView = (props) => {
  const { fetchPackageDeliveryRanges, clearPackageOrderList } = props;
  const [selectedDate, setSelectedDate] = useState(undefined);
  const [selectedDeliveryHour, setSelectedDeliveryHour] = useState(undefined);
  const [statusId, setStatusId] = useState(props.activeStatusId);
  const [packageNumber, setPackageNumber] = useState(undefined);
  const [orderNumber, setOrderNumber] = useState(undefined);

  const setFilterRequest = debounce(() => filterRequest(), 1000);

  const {
    location: { state = {} },
  } = props;

  const { params: { deliveryRangeId } = {} } = state;

  useEffect(() => {
    handleDeliveryDateChange(initialDeliveryDate);
    updateSelectedDeliveryHour(deliveryRangeId);
  }, []);

  useEffect(() => {
    updateSelectedDeliveryHour(deliveryRangeId);
    setStatusId(props.activeStatusId);
  }, [state]);

  const updateSelectedDeliveryHour = (deliveryRangeId) => {
    const { deliveryRanges = [] } = props;
    const selectedDeliveryHour = deliveryRanges.find(
      (item) => item.id === deliveryRangeId
    );
    setSelectedDeliveryHour(selectedDeliveryHour);
  };

  const initialDeliveryDate = () => {
    const { deliveryRanges = [] } = props;
    return deliveryRanges.length < 1
      ? moment()
      : moment(deliveryRanges[0].lower);
  };

  const filterPackageOrders = () => {
    const { filterPackageOrders } = props;
    const { id: deliveryRangeId, lower, upper } = selectedDeliveryHour;

    const _lower = lower || getIsoDate(selectedDate);

    if (_lower && statusId) {
      const params = {
        deliveryRangeId,
        state: statusId,
        delivery_range_lower: _lower,
        ...(packageNumber ? { number: packageNumber } : {}),
        ...(orderNumber ? { order_number: orderNumber } : {}),
        ...(upper ? { delivery_range_upper: upper } : null),
      };
      filterPackageOrders(params);
    }
  };

  const handleStatusChange = (id) => {
    setStatusId(id);
    setSelectedDate(undefined);
    setSelectedDeliveryHour(undefined);
    fetchPackageDeliveryRanges(selectedDate);
  };

  const handleDeliveryDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDeliveryHour(undefined);
    fetchPackageDeliveryRanges(selectedDate);
  };

  const filterRequest = () => {
    filterPackageOrders();
  };

  const handlePackageNumberChange = (e) => {
    const { value: packageNumber } = e.target;
    setPackageNumber(packageNumber);
    setFilterRequest();
  };

  const handleOrderNumberChange = (e) => {
    const { value: orderNumber } = e.target;
    setOrderNumber(orderNumber);
    setFilterRequest();
  };

  const handleDeliveryHourChange = (deliveryRangeId) => {
    const { deliveryRanges } = props;
    const deliveryRange = deliveryRanges.find(
      (item) => item.id === deliveryRangeId
    );
    if (deliveryRange) {
      setSelectedDeliveryHour(deliveryRange);
      clearPackageOrderList();
      filterPackageOrders();
    }
  };

  const redirectToDetail = (id) => {
    const { history } = props;
    const url = `${$R.PACKAGE_ORDER_DETAIL.path}/${id}`;
    history.push(url);
  };

  const rangeFormatter = ({ lower, upper }) => {
    return `${dateFormatter(lower, hourMinuteFormat)} - ${dateFormatter(
      upper,
      hourMinuteFormat
    )}`;
  };

  return (
    _content &&
    _content({
      props,
      selectedDate,
      selectedDeliveryHour,
      statusId,
      packageNumber,
      orderNumber,
      updateSelectedDeliveryHour,
      initialDeliveryDate,
      filterPackageOrders,
      handleStatusChange,
      handleDeliveryDateChange,
      handlePackageNumberChange,
      handleOrderNumberChange,
      handleDeliveryHourChange,
      redirectToDetail,
      rangeFormatter,
    })
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  fetchPackageDeliveryRanges,
  clearPackageOrderList,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(MobileView);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/oms/PackageOrderList/mobileView/index.js